import { createApp } from 'vue';
import App from './App.vue';
import store from './store'; // Import the store
import router from './router'; // Import the router
import clickOutside from './directives/clickOutside';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const app = createApp(App);

app.use(store); // Register Vuex store
app.use(router); // Register Vue Router
app.use(Toast);

app.directive('click-outside', clickOutside);

app.mount('#app'); // Mount the app
